module.exports = __webpack_public_path__ + "static/media/external-link.24b341b2.svg";